<template>
<div class="animated fadeIn">
    <b-card no-body class="bg-light">
    <b-row no-gutters>
        <b-col sm="6" lg="3">
            <ModelCount chartId="model" class="chart-wrapper" style="height:312px;margin-top:0px;"></ModelCount>
        </b-col>
        <b-col sm="6" lg="3">
            <Online chartId="online" class="chart-wrapper" style="height:312px;margin-top:0px;"></Online>
        </b-col>
        <b-col sm="6" lg="3">
            <TrafficWeekdayForm chartId="weekday" class="chart-wrapper" style="height:290px;margin-top:0px;"></TrafficWeekdayForm>
        </b-col>
        <b-col sm="6" lg="3">
            <TrafficHourForm chartId="hour" class="chart-wrapper" style="height:290px;margin-top:0px;"></TrafficHourForm>
        </b-col>
    </b-row>
    </b-card>
    <b-card no-body class="bg-light">
        <TrafficPlotForm></TrafficPlotForm>
    </b-card>

</div>
</template>

<script>
import ModelCount from './ModelCount'
import Online from './Online'
// import Traffic2 from './dash/Traffic-weekday'
// import Traffic3 from './dash/Traffic-hour'
import TrafficPlotForm from './TrafficPlotForm'
import TrafficWeekdayForm from './TrafficWeekdayForm'
import TrafficHourForm from './TrafficHourForm'

export default {
    name: 'dashboard',
    components: {
        TrafficPlotForm,
        ModelCount,
        Online,
        TrafficWeekdayForm,
        TrafficHourForm,
    },
    data: function () {
        return {
            selected: 'Month',
        }
    },
    methods: {

    },
    mounted() {

    }
}
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
    width: 100% !important;
}
</style>
